import { render, staticRenderFns } from "./renlianshibie.vue?vue&type=template&id=2d7794d9&scoped=true"
import script from "./renlianshibie.vue?vue&type=script&lang=js"
export * from "./renlianshibie.vue?vue&type=script&lang=js"
import style0 from "./renlianshibie.vue?vue&type=style&index=0&id=2d7794d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7794d9",
  null
  
)

export default component.exports